import { render } from "./Trucks.vue?vue&type=template&id=6457cf04&scoped=true"
import script from "./Trucks.vue?vue&type=script&lang=js"
export * from "./Trucks.vue?vue&type=script&lang=js"

import "./Trucks.vue?vue&type=style&index=0&id=6457cf04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6457cf04"]])

export default __exports__